import { useState, useContext } from 'react';

import '../CompaniesPage/CompaniesPage.css';
import { FinancialBuilderContext } from '../FinancialBuilderPage.jsx';

import { industryDetails, otherVariablesCostRenderFields } from '../../constants.jsx';
import { renderFormRow, genericPOSTDatabaseCall } from '../../helperFunctions.jsx';

async function saveCompanyToDatabase(company) {
    return genericPOSTDatabaseCall('/api/fb/saveCompanyInfo', { company }, 'company info');
}

function OtherVariablesCost({ contextToUse, renderFields }) {
    const { companySelected, messageApi, setCompanySelected } = useContext(contextToUse || FinancialBuilderContext);
    const [saving, setSaving] = useState(false);

    renderFields = renderFields || otherVariablesCostRenderFields;

    const handleSave = async () => {
        setSaving(true);
        messageApi.loading('Saving company info...', 0);
        try {
            await saveCompanyToDatabase({ ...companySelected, id: companySelected.fb_id !== undefined ? companySelected.fb_id : companySelected.id });
            messageApi.destroy();
            messageApi.success('Company info saved successfully');
        } catch (error) {
            console.error('Error saving company info:', error);
            messageApi.destroy();
            messageApi.error('Failed to save company info');
        }
        setSaving(false);
    };


    const handleInputChange = (event, company, key, field) => {
        let newValue = event.target.value;

        setCompanySelected(prev => ({
            ...prev,
            [key]: newValue
        }));
    }

    const handleInputBlur = (event, company, key, field) => {
        let newValue = event.target.value;

        if (field.regexCondition && field.errorMessage && !field.regexCondition.test(newValue)) {
            messageApi.error(field.errorMessage);
            newValue = industryDetails[company.industry][key] || field.default || ''; // Use default value if provided
        }

        if (newValue === '') {
            messageApi.error('This field cannot be empty');
            newValue = industryDetails[company.industry][key] || field.default || ''; // Use default value if provided
        }

        setCompanySelected(prev => ({
            ...prev,
            [key]: newValue
        }));
    }

    return (
        <div className="other-variables-cost financial-builder-container entity-industry-container">
            <h2>Other Variables</h2>
            <div className='entity-card'>
                {renderFields.map(field => (renderFormRow(field, companySelected, handleInputChange, true, handleInputBlur)))}
                <div className="flex-row bottom-actions">
                    <div className="form-row actions-row">
                        <button disabled={saving} onClick={handleSave} type="button" className="save-button">Save</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OtherVariablesCost;